import React, { useEffect, useState } from "react";
import useModalStore from "../StatesStore/ModalStore";

import { Copy } from "react-bootstrap-icons";
import {
  Form,
  InputGroup,
  Modal,
  Button,
  FormControl,
  OverlayTrigger,
  Tooltip,
  CloseButton,
} from "react-bootstrap";
import { message } from "antd";
import { UserAuth } from "../Context";
import { saveInviteToDb } from "../lib/saveInviteToDb";
import { checkIfEmailExists } from "../lib/checkIfEmailExists";
import { Link } from "react-router-dom";
import ProfilePicture from "../UserProfile/ProfilePicture";
import { CopyLink, Facebook, WhatsApp } from "../ShoppingList/SocialMediaSVGs";
const { InviteUser } = require("../EmailSystem/sendEmails");

function Invite() {
  const { data, title, closeModal } = useModalStore();
  const [Error, setError] = useState("");
  const { user } = UserAuth();
  const [emailUsers, setEmailUsers] = useState([]);
  const [emailInputValue, setEmailInputValue] = useState("");
  const text = "Invite Friends";
  const myEmail = user?.providerData[0].email;
  const modified = data.replace(
    "http://localhost:3000",
    "https://lookflock.com"
  );
  const [inviteOption, setInviteOption] = useState("email");
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const checkEmails = async (email) => {
    if (email === myEmail) {
      setError("Cannot email yourself");
      return false; // Email is same as user's email
    }
    if (emailUsers.includes(email)) {
      setError("Emails should be unique");
      return false; // Duplicate found
    }
    const emailExists = await checkIfEmailExists(email);
    if (emailExists.exists) {
      const handleLinkClick = () => {
        closeModal(); // Close the modal when the link is clicked
      };

      const userLink = (
        <Link
          to={`/userProfile/${emailExists.userId}`}
          onClick={handleLinkClick}
        >
          {emailExists.firstName}
        </Link>
      );

      // Set the error state with the clickable link
      setError(
        <>
          {email} is already on Lookflock. Add {userLink} and invite them
          directly.
        </>
      );

      return false;
    }
    return true;
  };
  const onEmailFinish = async (values) => {
    if (values.length === 0) {
      if (isValidEmail(emailInputValue)) {
        if (await checkEmails(emailInputValue)) {
          values.push(emailInputValue);
        }
      } else {
        setError("Please enter a valid email");
        return;
      }
    }
    values.forEach(async (email) => {
      // console.log(user, data);
      InviteUser(user?.displayName, email, data)
        .then(() => {
          message.success({
            content: `Email sent successfully to ${email}`,
            key: "success",
          });
        })
        .catch((error) => {
          message.error(`Error sending email to ${email}`);
          console.error("Error sending email:", error);
        });

      closeModal();
      await saveInviteToDb(
        {
          name: "",
          email,
          type: "email",
        },
        user
      );
    });
  };

  const handleCopyLink = () => {
    const fullLink = data.replace(
      "http://localhost:3000",
      "https://lookflock.com"
    );
    navigator.clipboard.writeText(fullLink); // Copy link to clipboard
    message.success({
      content: `Link copied`,
      key: "success",
    });
  };

  const handleFacebookShare = () => {
    const shareQuote = encodeURIComponent(text);
    window.open(
      `https://www.facebook.com/sharer/sharer.php?u=https://lookflock.com/#/ProductDetails/${text}&quote=${shareQuote}`
    );
  };

  const handleWhatsappShare = () => {
    window.open(
      `https://api.whatsapp.com/send?text=${encodeURIComponent(
        `${text}: ${data}`
      )}`
    );
  };

  const handleEmailChange = (e) => {
    setError("");
    setEmailInputValue(e.target.value);
  };

  const isValidEmail = (email) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());

  const handleKeyDown = async (e) => {
    if (["Enter", ",", " "].includes(e.key)) {
      e.preventDefault();
      const trimmed = emailInputValue.trim().replace(/,$/, "");
      if (
        trimmed &&
        isValidEmail(trimmed) &&
        (await checkEmails(e.target.value))
      ) {
        if (!emailUsers.includes(trimmed)) {
          setEmailUsers([...emailUsers, trimmed]);
        }
        setEmailInputValue("");
      }
    }
  };

  const removeEmail = (removeIndex) => {
    setEmailUsers(emailUsers.filter((_, index) => index !== removeIndex));
  };
  return (
    <>
      <style jsx>
        {`
          .inviteFriendsModal .modal-content {
            border-radius: 20px !important;
            width: 36rem;
            overflow: hidden;
            max-height: 660px;
          }

          .inviteFriendsModal .modal-dialog {
            max-width: 36rem;
            margin: 1rem auto; /* Add some margin */
          }
        `}
      </style>
      <Modal
        className="inviteFriendsModal"
        show={true}
        centered
        onHide={closeModal}
      >
        <Modal.Body style={{ padding: isSmallScreen ? "20px" : "40px" }}>
          {/* Invite via email */}
          <div className="d-flex flex-column mb-3">
            <div className="d-flex w-100 justify-content-between">
              <div
                style={{
                  fontFamily: "Inter",
                  color: "#101828",
                  fontWeight: "600",
                  fontSize: isSmallScreen ? "18px" : "24px",
                  lineHeight: isSmallScreen ? "18px" : "24px",
                  letterSpacing: "0%",
                }}
              >
                Invite Friends
              </div>
              <button
                type="button"
                style={{
                  boxSizing: "border-box",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "27px",
                  height: "27px",
                  background: "#FFFFFF",
                  border: "1px solid #FF3B30",
                  boxShadow: "1px 1px 5px rgba(30, 30, 30, 0.14)",
                  borderRadius: "25px",
                  flex: "none",
                  order: "1",
                  flexGrow: "0",
                }}
                onClick={closeModal}
              >
                <svg
                  style={{ width: "11px" }}
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M13 1L1 13M1 1L13 13"
                    stroke="#FF3B30"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>
            </div>
          </div>
          <div className="d-flex align-items-center" style={{ gap: "60px" }}>
            <div
              onClick={() => setInviteOption("email")}
              className="linkStyle"
              style={{
                borderBottom:
                  inviteOption === "email" ? `1px solid rgb(0, 95, 218)` : "",
                color: inviteOption === "email" ? "#005FDA" : "#667085",
                fontSize: "18px",
                fontWeight: 500,
                margin: 0,
                cursor: "pointer",
              }}
            >
              Email
            </div>
            <div
              onClick={() => setInviteOption("link")}
              className="linkStyle"
              style={{
                borderBottom:
                  inviteOption === "link" ? `1px solid rgb(0, 95, 218)` : "",
                color: inviteOption === "link" ? "#005FDA" : "#667085",
                fontSize: "18px",
                fontWeight: 500,
                margin: 0,
                cursor: "pointer",
              }}
            >
              Link
            </div>
          </div>
          <div className="mt-4">
            {inviteOption === "email" ? (
              <div>
                <Form
                  className="d-flex flex-column gap-1"
                  onSubmit={async (e) => {
                    e.preventDefault();
                    onEmailFinish(emailUsers);
                  }}
                >
                  <div>
                    {emailUsers.length > 0 && (
                      <div
                        className="d-flex align-items-center gap-2 mb-2"
                        style={{
                          overflowX: "auto",
                          scrollbarWidth: "thin",
                          paddingBottom: "4px",
                        }}
                      >
                        {emailUsers.map((email, index) => (
                          <Button
                            key={index}
                            size="sm"
                            variant="primary-soft"
                            className="d-flex align-items-center"
                          >
                            {email}
                            <CloseButton
                              className="ms-2"
                              onClick={() => removeEmail(index)}
                            />
                          </Button>
                        ))}
                      </div>
                    )}
                    <div className="d-flex gap-2 align-items-center">
                      <Form.Control
                        type="text"
                        placeholder="email@example.com"
                        className="rounded-2 h-50"
                        value={emailInputValue}
                        onChange={handleEmailChange}
                        onKeyDown={handleKeyDown}
                      />
                      <OverlayTrigger
                        placement="right"
                        overlay={
                          <Tooltip>
                            Press enter after typing each email address. You can
                            add up to 10 email addresses.
                          </Tooltip>
                        }
                      >
                        <i
                          style={{ cursor: "pointer", color: "#0f6fec" }}
                          className="bi bi-info-circle"
                        ></i>
                      </OverlayTrigger>
                    </div>
                  </div>
                  <span className="text-danger">{Error}</span>
                  <div className="d-flex justify-content-end mt-3">
                    <Button
                      className="rounded-3 w-100"
                      type="submit"
                      disabled={
                        emailUsers.length === 0 && emailInputValue.length === 0
                      }
                      variant="primary"
                    >
                      <span>Invite</span>
                    </Button>
                  </div>
                </Form>
              </div>
            ) : (
              <div className="d-flex flex-column" style={{ gap: "12px" }}>
                <p
                  className="mb-0"
                  style={{
                    fontSize: "0.89rem",
                    color: "gray",
                  }}
                >
                  Copy a view-only link and share with anyone — no account
                  required.
                </p>
                <InputGroup>
                  <Form.Control
                    className="rounded-3 me-1 text-mute pe-5"
                    value={modified}
                    readOnly
                  />
                  <div
                    className="rounded me-3 mt-2 position-absolute end-0"
                    style={{ zIndex: "10", cursor: "pointer" }}
                    onClick={handleCopyLink}
                  >
                    <Copy className="fs-6" />
                  </div>
                </InputGroup>
                <div className="d-flex flex-column" style={{ gap: "4px" }}>
                  <div
                    style={{
                      fontFamily: "Inter",
                      fontWeight: 500,
                      fontSize: "16px",
                      lineHeight: "100%",
                      letterSpacing: "0%",
                      color: "black",
                    }}
                  >
                    Share By
                  </div>
                  <div
                    className="d-flex justify-content-center"
                    style={{ gap: "16px" }}
                  >
                    <span
                      style={{ cursor: "pointer" }}
                      onClick={handleFacebookShare}
                    >
                      <Facebook />
                    </span>
                    <span
                      style={{ cursor: "pointer" }}
                      onClick={handleWhatsappShare}
                    >
                      <WhatsApp />
                    </span>
                    {/* <span
                      style={{ cursor: "pointer" }}
                      onClick={handleCopyLink}
                    >
                      <CopyLink />
                    </span> */}
                  </div>
                </div>
              </div>
            )}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default Invite;
